<section class="page">
  <header class="page-header">
    <h2>Modifier un capteur fabriqué</h2>

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }
  </header>

  <form (ngSubmit)="submit()" class="panel">
    <fieldset>
      <legend>Sélection du capteur fabriqué</legend>
      @if (loadingCapteurs) {
        <p>Chargement des capteurs fabriqués...</p>
      }
      @if (!loadingCapteurs) {
        <label for="capteur-fabrique">Capteur fabriqué</label>
        <input id="capteur-fabrique" type="text"
          [ngModel]="capteurFabriqueInput"
          (ngModelChange)="onCapteurFabriqueInputChange($event)"
          name="capteurFabriqueInput"
          [matAutocomplete]="autoCapteurFabrique" autocomplete="off" />
        <mat-autocomplete #autoCapteurFabrique="matAutocomplete" (optionSelected)="onCapteurFabriqueSelected($event)">
          @for (capteur of filteredCapteursFabriques; track capteur.id) {
            <mat-option [value]="capteur">{{ capteur.numero_serie }}</mat-option>
          }
        </mat-autocomplete>
      }
    </fieldset>

    @if (selectedCapteurId) {
      <fieldset>
        <legend>Informations principales</legend>

        <label for="numero-serie">Numéro de série</label>
        <input id="numero-serie" type="text" [(ngModel)]="numeroSerie" name="numeroSerie" />

        <label for="numero-nomenclature">Numéro de nomenclature</label>
        <select id="numero-nomenclature" [(ngModel)]="numeroNomenclature" name="numeroNomenclature">
          <option value="">-- sélectionner --</option>
          @for (nomenclature of nomenclatures; track nomenclature.id) {
            <option [value]="nomenclature.id">N° {{ nomenclature.numero_nomenclature }} - {{ nomenclature.nom }} ({{ nomenclature.date_creation }})</option>
          }
        </select>
        @if (loadingNomenclatures) {
          <p>Chargement des nomenclatures...</p>
        }

        <label for="date-assemblage">Date d'assemblage</label>
        <input id="date-assemblage" type="date" [(ngModel)]="dateAssemblage" name="dateAssemblage" />

        <label for="type-capteur">Type de capteur</label>
        <select id="type-capteur" [(ngModel)]="typeCapteur" name="typeCapteur" (ngModelChange)="onTypeCapteurChange()">
          <option value="">-- sélectionner --</option>
          @for (type of typeCapteurs; track type.id) {
            <option [value]="type.nom">{{ type.nom }}</option>
          }
        </select>

         <label for="mac-carte">Code MAC carte électronique</label>
        <input id="mac-carte" type="text" [(ngModel)]="macCarteElectronique" name="macCarteElectronique" />
      </fieldset>
      <fieldset>
        <legend>Lignes de commande</legend>
        <label for="ligne-commande">Ligne de commande (en cours de préparation)</label>
        <select id="ligne-commande" [(ngModel)]="selectedLigneCommandeId" name="selectedLigneCommandeId" (ngModelChange)="onLigneCommandeChange()">
          <option [ngValue]="null">-- aucune --</option>
          @for (option of lignesCommandeEnPreparation; track option.id) {
            <option [ngValue]="option.id">{{ option._affichage }}</option>
          }
        </select>


       
      </fieldset>

      <fieldset>





        <legend>Cartouches</legend>


        <label for="cartouche-a">{{ getCartoucheALabel() }}</label>
        <input id="cartouche-a" type="text" [matAutocomplete]="autoCartoucheA" [(ngModel)]="cartoucheAInput" name="cartoucheAInput" (ngModelChange)="onCartoucheAInputChange($event)" (focus)="onCartoucheAInputChange(cartoucheAInput)" autocomplete="off" />
        <mat-autocomplete #autoCartoucheA="matAutocomplete" [displayWith]="displayCartouche" (optionSelected)="onCartoucheASelected($event)">
          @for (cartouche of filteredCartouchesA; track cartouche.id) {
            <mat-option [value]="cartouche">{{ cartouche.nom }}</mat-option>
          }
        </mat-autocomplete>
        <label for="lot-a">{{ getLotCartoucheALabel() }}</label>
        <input id="lot-a" type="text" [value]="lotCartoucheAName" readonly />

        @if (!isSingleCartoucheType()) {
          <label for="cartouche-b">Cartouche B</label>
          <input id="cartouche-b" type="text" [matAutocomplete]="autoCartoucheB" [(ngModel)]="cartoucheBInput" name="cartoucheBInput" (ngModelChange)="onCartoucheBInputChange($event)" (focus)="onCartoucheBInputChange(cartoucheBInput)" autocomplete="off" />
          <mat-autocomplete #autoCartoucheB="matAutocomplete" [displayWith]="displayCartouche" (optionSelected)="onCartoucheBSelected($event)">
            @for (cartouche of filteredCartouchesB; track cartouche.id) {
              <mat-option [value]="cartouche">{{ cartouche.nom }}</mat-option>
            }
          </mat-autocomplete>
          <label for="lot-b">Lot cartouche B</label>
          <input id="lot-b" type="text" [value]="lotCartoucheBName" readonly />
        }
        

        
      </fieldset>
    

      <fieldset>
        <legend>Retour et expédition</legend>

        <label for="reference-envoi">Référence d'envoi</label>
        <input id="reference-envoi" type="text" [(ngModel)]="referenceEnvoi" name="referenceEnvoi" maxlength="30" />

        <label for="date-expedition-capteur">Date d'expédition du capteur</label>
        <input id="date-expedition-capteur" type="date" [(ngModel)]="dateExpeditionCapteur" name="dateExpeditionCapteur" />

        <label for="code-bon-retour">Code bon retour Capteur</label>
        <input id="code-bon-retour" type="text" [(ngModel)]="codeBonRetour" name="codeBonRetour" maxlength="30" />

        <label for="code-bon-retour-cartouches">Code bon retour cartouches</label>
        <input id="code-bon-retour-cartouches" type="text" [(ngModel)]="codeBonRetourCartouches" name="codeBonRetourCartouches" maxlength="30" />

        
      </fieldset>

      <fieldset>
        <legend>Fonctionnement et volumes</legend>
        <label for="date-retour">Date de retour</label>
        <input id="date-retour" type="date" [(ngModel)]="dateRetour" name="dateRetour" />
        <label for="nombre-heures">Nombre d'heures de fonctionnement</label>
        <input id="nombre-heures" type="text" maxlength="6" pattern="[0-9]{3}h[0-9]{2}" placeholder="008h12" title="Format attendu : 008h12" [(ngModel)]="nombreHeuresFonctionnement" name="nombreHeuresFonctionnement" />

        <label for="nombre-litres">Nombre de litres aspirés</label>
        <input id="nombre-litres" type="number" step="0.01" [(ngModel)]="nombreLitresAspires" name="nombreLitresAspires" />

        <label for="commentaire">Commentaire</label>
        <textarea id="commentaire" [(ngModel)]="commentaire" name="commentaire"></textarea>
      </fieldset>
      <fieldset>
      <legend>Statut et test moteur</legend>
        <label for="statut">Statut</label>
        <select id="statut" [(ngModel)]="statutCapteurId" name="statutCapteurId">
          <option value="">-- sélectionner --</option>
          @for (statut of statutsCapteurs; track statut.id) {
            <option [value]="statut.id">{{ statut.nom }}</option>
          }
        </select>

        @if (isStatutEnCoursDeTransit()) {
          <label for="date-envoi">Date d'envoi</label>
          <input id="date-envoi" type="date" [(ngModel)]="dateEnvoi" name="dateEnvoi" />
        }
        <div style="width:300px">
          <label for="presence-cartouche" style="display:inline-block">
          
            Présence de cartouche
          </label>
        <input style="display:inline-block;width:50px;" id="presence-cartouche" type="checkbox" [(ngModel)]="presenceCartouche" name="presenceCartouche" />
        </div>
        <div style="width:300px">

          <label for="test-moteur" style="display:inline-block">
            
            Test moteur réussi
          </label>
          <input id="test-moteur" style="display:inline-block;width:50px;" type="checkbox" [(ngModel)]="testMoteur" name="testMoteur" />
        </div>
      </fieldset>
      <button type="submit" [disabled]="loading">{{ loading ? 'Modification...' : 'Enregistrer' }}</button>
    }
  </form>
</section>
